import {ChangeDetectionStrategy, Component, Input, OnInit, ViewEncapsulation} from '@angular/core';

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    selector: 'emm-menu-layout',
    styleUrls: ['./menu-layout.component.scss'],
    templateUrl: './menu-layout.component.html'
})
export class MenuLayoutComponent implements OnInit {

  @Input() sidenavOpened: boolean; // TODO: no longer use, need to restore?

  constructor() {}

  ngOnInit(): void {}

}
